import firebase from 'firebase/app'
import { notification } from 'antd'
import 'firebase/auth'
import 'firebase/database'
import axios from 'axios';

const functionsEmulatorUrl = "http://localhost:5001";

async function initializeApp() {
  if (firebase.apps.length === 0) {
    const initConfig = await fetch('/__/firebase/init.json');
    firebase.initializeApp(await initConfig.json());
    const functions = firebase.app().functions("australia-southeast1");
    if (window.location.hostname === "localhost") {
      functions.useFunctionsEmulator(functionsEmulatorUrl);
    }
  }
}

export async function forgot_password(email) {
  await initializeApp();
  const actionCodeSettings = {
    url: 'https://apollo-partner.web.app',
    handleCodeInApp: false
  };

  const authProviderPromise = firebase.app().auth().sendPasswordResetEmail(email, actionCodeSettings)

  return authProviderPromise
      .then(() => {
        return true;
      })
      .catch(error => {
        notification.warning({
          message: error.code,
          description: error.message,
        });

      });
}

export async function email_login(email, password) {
  await initializeApp();
  const authProviderPromise = firebase.app().auth().signInWithEmailAndPassword(email, password)

  return authProviderPromise
      .then(() => {
        return true;
      })
      .catch(error => {
        notification.warning({
          message: error.code,
          description: error.message,
        });

      });
}

export async function login() {
  await initializeApp();

  const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
  const authProviderPromise = firebase.app().auth().signInWithPopup(googleAuthProvider);

  return authProviderPromise
      .then(() => {
        console.log("Successfully logged in!")
        return true;
      })
      .catch(error => {
        console.log("Error Authenticating: ", error)
        notification.warning({
          message: error.code,
          description: error.message,
        });
      });
}

export async function myobLogin() {
  await initializeApp();

  const samlAuthProvider = new firebase.auth.SAMLAuthProvider('saml.myob');
  const signIn = firebase.app().auth().signInWithPopup(samlAuthProvider);

  return signIn
    .then(() => {
      console.log("Successfully logged in!")
      return true;
    })
    .catch(error => {
      console.log("Error Authenticating: ", error)
      notification.warning({
        message: error.code,
        description: error.message,
      });
    });
}

export async function currentProfile() {
  await initializeApp();
}

// current code in apollo
export async function currentAccount() {
  await initializeApp();

  let userLoaded = false
  function getCurrentUser(auth) {
    console.log("Getting Current User")
    return new Promise((resolve, reject) => {
      if (userLoaded) {
        resolve(firebase.auth().currentUser)
      }

      console.log("Current User: ", firebase.auth().currentUser)
      
      const unsubscribe = auth.onAuthStateChanged( async user => {
            if (user && user.uid) {
              const userId = user.uid;
              const name = user.displayName;
              const email = user.email;
              const avatar = user.photoURL

              axios.interceptors.request.use(async config => {
                config.headers.token = firebase.app().auth().currentUser ? await firebase.app().auth().currentUser.getIdToken(false) : '';
                return config;
              }, error => {
                return Promise.reject(error)
              });

              userLoaded = true;
              unsubscribe();
              
              let demoUser, details;

              if (!email.includes('@flarehr.com') && !email.includes('@myob.com')) {
                demoUser = await firebaseGet("getDemoUser", {id: userId});
              }
              
              const userWithDetails = {
                ...user,
                userId,
                demoUser
              }
              resolve(userWithDetails)

            } else {

              userLoaded = false;
              unsubscribe();
              
              const userWithDetails = {
                details: { 
                  "primaryColor": "#4b53bc", 
                  "partnerLogo": "/resources/images/logo.svg" 
                }
              }
              resolve(userWithDetails)
            }
          },
          reject
      )
    })
  }
  return getCurrentUser(firebase.app().auth())
}

export async function logout() {
  await initializeApp();
  return firebase.auth().signOut().then(() => true)
}

export class ApolloError extends Error {
  constructor( {status, message, details} ) {
    super(message || 'An unknown error occurred');
    this.status = status;
    this.details = details;
  }

  static GetApolloErrorMessageOrDefault(error, defaultMessage = "Unknown Error")
  {
    if (error instanceof ApolloError)
    {
      return error.message
    }

    return defaultMessage
  }

  static isApolloError(responseData)  {
    return (
      responseData &&
      responseData.originalError
    );
  }

  static tryParse(responseData) {
    if (ApolloError.isApolloError(responseData))
    {
       let errorMessage = responseData.originalError.data && responseData.originalError.data.message;
       const status = responseData.originalError.status;
       if (!errorMessage)
       {
         switch (status) {
           case 401:
             errorMessage = "Unauthorized access.Please check your credentials.";
             break;
           case 403:
             errorMessage = "Forbidden access. You do not have the necessary permissions.";
             break;          
           case 404:
             errorMessage = "Requested resource not found.";
             break;
           case 429:
             errorMessage = "Too many requests. Please try again later.";
             break;
           case 500:
             errorMessage = "Something Went Wrong. Please try again later.";
             break;
           case 400:
             errorMessage = responseData.originalError.data || "Validation Error.";
               break;
           default:
             errorMessage = `Unexpected error occurred (status code: ${status}).`;
         }
       }

      return new ApolloError({status, message: errorMessage, details: responseData.originalError.data});
    }

    return null;
  }
}

export async function firebaseGet(endpoint, data) {
  await initializeApp();

  const functions = firebase.app().functions("australia-southeast1");
  if (window.location.hostname === "localhost") {
    functions.useFunctionsEmulator(functionsEmulatorUrl);
  }
  const requestEndPoint = functions.httpsCallable(endpoint);
  // const requestEndPoint = firebase.app().functions("australia-southeast1").httpsCallable(endpoint);
  let response = null;
  try {
    
    response = await requestEndPoint(data);
  } catch (error) {
    console.log(`Error in call endpoint ${endpoint} : Error: ${error}`);
    throw error;
  }
    if (!response.data) {
      return null;
    }
    const apolloError = ApolloError.tryParse(response.data);
    if ( apolloError)
    {
       throw apolloError;
    }

    return response.data;   
}